/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { LoggerService } from './logger.model';

@Injectable()
export class ProdLoggerService implements LoggerService {
  trace(...messages: unknown[]): void {
    // do nothing
  }

  debug(...messages: unknown[]): void {
    // do nothing
  }

  log(...messages: unknown[]) {
    console.log.apply(null, messages);
  }

  warn(...messages: unknown[]) {
    console.warn.apply(null, messages);
  }

  error(...messages: unknown[]) {
    console.error.apply(null, messages);
  }
}
